import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

/** Compact editorial hero used at the top of every interior page. */
export default function PageHeader({ eyebrow, title, accent, intro, image, imagePosition = "center", crumb }) {
  return (
    <section
      data-testid="page-header"
      className="relative pt-36 pb-16 md:pt-44 md:pb-24 overflow-hidden bg-[var(--bg-deepest)] grain"
    >
      {image && (
        <>
          <img
            src={image}
            alt=""
            aria-hidden
            className="absolute inset-0 w-full h-full object-cover hero-image"
            style={{ objectPosition: imagePosition }}
          />
          <div
            aria-hidden
            className="absolute inset-0"
            style={{
              background:
                "linear-gradient(180deg, rgba(10,10,10,0.75) 0%, rgba(10,10,10,0.6) 50%, rgba(10,10,10,0.97) 100%)",
            }}
          />
        </>
      )}
      <div className="relative z-10 container-x">
        <nav aria-label="Breadcrumb" className="flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.22em] text-white/40 mb-8" data-testid="breadcrumb">
          <Link to="/" className="hover:text-white transition-colors" data-testid="breadcrumb-home">Home</Link>
          <ChevronRight size={12} />
          <span className="text-[var(--brand-yellow)]">{crumb || title}</span>
        </nav>
        {eyebrow && <p className="eyebrow mb-4" data-testid="page-eyebrow">{eyebrow}</p>}
        <h1
          data-testid="page-title"
          className="font-display font-black uppercase leading-[0.92] tracking-tight text-white text-4xl sm:text-5xl lg:text-6xl xl:text-[88px]"
        >
          {title} {accent && <span className="brand-red">{accent}</span>}
        </h1>
        {intro && (
          <p data-testid="page-intro" className="mt-6 text-base md:text-lg text-white/65 leading-relaxed max-w-2xl">
            {intro}
          </p>
        )}
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-[3px] bg-gradient-to-r from-[var(--brand-red)] via-[var(--brand-red)]/40 to-transparent" />
    </section>
  );
}
